import { render, staticRenderFns } from "./TermsAcceptance.vue?vue&type=template&id=688a8a01&"
import script from "./TermsAcceptance.vue?vue&type=script&lang=ts&"
export * from "./TermsAcceptance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports